import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Text,
  IconButton,
  Spacer,
  HStack,
  VStack,
  Button,
  Textarea,
  Flex,
} from '@chakra-ui/react';
import { CloseCircleOutline, YellowWarningBold } from '@aslanpay/portal-common-lib';
import { useState, useCallback } from 'react';
import { RejectRecognitionModalProps } from 'app/components/Modals/RecognitionApprovalsModals/RecognitionApprovalsModals.types';

const REASON_MAX_LENGTH = 500;

function RejectRecognitionModal({
  isOpen,
  onClose,
  onConfirm,
  pendingItems,
  isEscalation = false,
}: RejectRecognitionModalProps) {
  const [reason, setReason] = useState('');
  const isBulkAction = pendingItems.length > 1;
  const count = pendingItems.length;
  const displayWarning = isEscalation || isBulkAction;

  const handleConfirm = useCallback(() => {
    onConfirm(reason);
    setReason('');
  }, [onConfirm, reason]);

  const handleClose = useCallback(() => {
    setReason('');
    onClose();
  }, [onClose]);

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent sx={{ maxWidth: '592px !important' }}>
        <ModalHeader pb={4}>
          <HStack align="flex-start">
            <Flex direction="row" align="center" gap={2}>
              {displayWarning && <YellowWarningBold boxSize="24px" />}
              <Text as="h4" textStyle="h4Bold" color="brand.black">
                {isBulkAction
                  ? `Decline ${count} recognitions?`
                  : `Decline ${isEscalation ? 'escalation' : 'recognition'}?`}
              </Text>
            </Flex>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close modal"
              onClick={handleClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody pb={6}>
          <VStack spacing={6} align="stretch">
            <VStack spacing={2} align="stretch">
              <Text>
                {`Please provide a reason for declining ${
                  count === 1 ? 'this recognition' : `${count} recognitions`
                }. The sender will be notified.`}
              </Text>
              <Textarea
                placeholder="Your reason for declining"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows={3}
                maxLength={REASON_MAX_LENGTH}
              />
              <Text textAlign="right" color="brand.mediumGray2" fontSize="sm">
                {reason.length}/{REASON_MAX_LENGTH}
              </Text>
            </VStack>
            <HStack spacing={3} justify="flex-end">
              <Button variant="outline" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleConfirm} isDisabled={!reason.trim()}>
                Decline
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default RejectRecognitionModal;
